const buildTexts = (config = {}, time = {}) => {
  const CURRENT_YEAR = time.appYear || new Date().getFullYear();
  const PREVIOUS_YEAR = CURRENT_YEAR - 1;
  const INVITATION_SENT_DATE = config.invitationSentDate || '';

  return {
    // Search and UI
    SEARCH_PLACEHOLDER: 'மொபைல் எண்ணை உள்ளிடவும்',
    SEARCH_BUTTON: 'தேடு',
    SEARCH_HELP: '',
    NO_DATA_FOUND: 'தகவல் கிடைக்கவில்லை\n\nதயவுசெய்து சரியான எண்ணை உள்ளிடவும்',
    LOADING_ALT: 'Loading',

    // Header
    TEMPLE_NAME: 'அருள்மிகு கொண்டறங்கி மல்லிகார்ஜுன சுவாமி திருக்கோயில்',
    TEMPLE_SUBTITLE: '(சுயம்பு லிங்கத் திருமேனி)',
    TEMPLE_LOCATION: 'கொண்டறங்கி கீரனூர்',
    TEMPLE_CELEBRATION: `ஸ்ரீ கைலாய ஆஸ்ரமத்தின் ${time.festivalCount}ஆம் ஆண்டு விழா`,

    // Footer
    NOTE_LABEL: 'குறிப்பு:',
    NOTE_TEXT:
      'அழைப்பிதழில்  இருக்கும் {year} ஆண்டுக்கான நன்கொடையாளர்கள் தகவல்களை  மட்டுமே இங்கே காணலாம்.',
    COPYRIGHT: 'பதிப்புரிமை',
    DATA_REFRESH: 'The data was last refreshed on {timestamp}.',

    // WhatsApp
    SHARE_ON_WHATSAPP: 'Share on WhatsApp',
    WHATSAPP_ALT: 'WhatsApp',
    YEAR_LABEL: 'ஆண்டு:-',
    DONOR_ID_LABEL: 'பதிவு எண்:-',
    BOOK_FORMAT_LABEL: 'புத்தகத்தில் அச்சிடப்பட்ட வடிவம்:-',
    POSTAL_ADDRESS_LABEL: 'அஞ்சல் முகவரி:-',
    PHONE_LABEL: 'அலைபேசி:-',
    PAGE_NUMBER_LABEL: 'புத்தகப் பக்கம் எண்:-',
    POSTAL_STATUS_LABEL: 'அழைப்பிதழ் அஞ்சல் மூலம் அனுப்பப்பட்டதா?:-',
    MORE_DETAILS_LABEL: 'மேலும் தகவல்கள் இங்கே:-',
    POSTAL_SENT_STATUS: 'அஞ்சல் அனுப்பப்பட்டுள்ளது',
    POSTAL_NOT_SENT_STATUS: 'அஞ்சல் அனுப்பப்படவில்லை',

    // IVR Status
    IVR_STATUS_TITLE: 'வாய்ஸ் கால் ஸ்டேடஸ்',
    MOBILE_NUMBER: 'எண்',
    STATUS: 'Status',
    DATE: 'தேதி',

    // Invitation
    INVITATION_SENT: `அழைப்பிதழ் ${INVITATION_SENT_DATE} அன்று அஞ்சல் மூலம் அனுப்பப்பட்டுள்ளது.`,
    DOWNLOAD_INVITATION: 'Download Full Invitation Book',
    DOWNLOAD_AGENDA: 'Download Festival Agenda',
    SHARE_WHATSAPP: 'Share Invitation on WhatsApp',

    // Donor sections
    SANDHA_TITLE: 'ஆண்டு சந்தா',
    DONATION_TITLE: 'பொருள் நன்கொடை',
    SANDHA_AMOUNT:
      'இந்த ஆண்டு முதல், ஆண்டு சந்தா ரூ.1,000 யாக உயர்த்தப்பட்டுள்ளது.',
    SANDHA_RECORDS: 'சந்தா பதிவுகள் உள்ளன',

    // Donor card fields
    DONOR_ID: 'பதிவு எண்:',
    LOCALITY: 'ஊர்:',
    PHONE: 'அலைபேசி:',
    DONATION_ITEM: 'நன்கொடை பொருள்:',
    POSTAL_ADDRESS: 'அஞ்சல் முகவரி:',
    PAGE_NUMBER: 'புத்தகப் பக்க எண்:',
    CURRENT_STATUS: 'Current Status:',

    // Postal status
    POSTAL_SENT: 'தபால் அனுப்பபட்டுள்ளது',
    POSTAL_SOON: 'தபால் விரைவில் அனுப்பப்படும்',
    POSTAL_NOT_SENT: 'தபால் அனுப்பப்படவில்லை',
    POSTAL_WILL_NOT_SENT: 'தபால் அனுப்பப்படாது',
    LOCAL_DONOR_REASON:
      'காரணம்: கோவில் கிராமத்தைச் சேர்ந்த நன்கொடையாளர்களுக்கு, அழைப்பிதழ்கள் அஞ்சல் மூலம் அனுப்பப்படுவதில்லை',
    REASON: 'காரணம்:',
    REJECTED_DATE: 'Rejected தேதி:',

    // Correction button
    CORRECTION_NEEDED: 'திருத்தம் தேவையா? இங்கே கிளிக் செய்யவும்',

    // Change Request Form
    CHANGE_REQUEST_TITLE: 'திருத்தக் கோரிக்கைப் படிவம்',
    PRINT_NAME_LABEL: 'பெயர்கள் (புத்தகத்தில் அச்சிடப்படும்)',
    PRINT_NAME_PLACEHOLDER: 'உங்கள் பெயரை உள்ளிடவும்',
    ADDRESS_LABEL: 'முகவரி (அஞ்சல் முகவரி)',
    ADDRESS_PLACEHOLDER: 'முழு முகவரியை உள்ளிடவும்',
    SUBMIT_BUTTON: 'சமர்ப்பிக்கவும்',
    SUBMITTING_BUTTON: 'சமர்ப்பிக்கப்படுகிறது...',
    CANCEL_BUTTON: 'ரத்து செய்யவும்',
    REQUIRED_FIELD: '*',
    CONFIRM_SUBMIT_TITLE: 'உறுதிப்படுத்தவும்',
    CONFIRM_SUBMIT_MESSAGE:
      'நீங்கள் உள்ளிட்ட தகவல்கள் சரியானவையா? சமர்ப்பிக்க விரும்புகிறீர்களா?',
    CONFIRM_YES: 'ஆம், சமர்ப்பிக்கவும்',
    CONFIRM_NO: 'இல்லை',
    RECAPTCHA_NOTICE: 'This site is protected by reCAPTCHA and the Google ',
    PRIVACY_POLICY: 'Privacy Policy',
    TERMS_OF_SERVICE: 'Terms of Service',
    RECAPTCHA_APPLY: ' apply.',

    // Change Request Success
    SUCCESS_TITLE: 'வெற்றி!',
    SUCCESS_MESSAGE:
      'உங்கள் திருத்தக் கோரிக்கை வெற்றிகரமாகச் சமர்ப்பிக்கப்பட்டது.',
    REFERENCE_NUMBER: 'குறிப்பு எண்:',
    COPY_REFERENCE: 'குறிப்பு எண் நகலெடுக்கவும்',
    REFERENCE_COPIED: 'குறிப்பு எண் நகலெடுக்கப்பட்டது!',
    GO_HOME: 'முகப்புக்குச் செல்லவும்',
    AUTO_REDIRECT:
      '{seconds} விநாடிகளில் முகப்புப் பக்கத்திற்கு தானியங்கி செல்லப்படும்...',

    // Change Request Error
    ERROR_TITLE: 'பிழை!',
    ERROR_MESSAGE:
      'உங்கள் கோரிக்கையை சமர்ப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
    ERROR_CONTACT: 'உதவிக்குத் தொடர்பு கொள்ளவும்:',
    RETRY_BUTTON: 'மீண்டும் முயற்சிக்கவும்',
    RATE_LIMIT_ERROR:
      'அதிகக் கோரிக்கைகள். தயவுசெய்து சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்.',

    // Validation Messages
    NAME_REQUIRED: 'பெயர்கள் (புத்தகத்தில் அச்சிடப்படும்)',
    NAME_MAX_LENGTH: 'பெயர் 255 எழுத்துக்களுக்கு மேல் இருக்கக்கூடாது',
    ADDRESS_REQUIRED: 'முகவரி தேவை',
    RECAPTCHA_ERROR: 'reCAPTCHA சரிபார்ப்பு தோல்வி. மீண்டும் முயற்சிக்கவும்.',
    MOBILE_REQUIRED: 'அலைபேசி எண் தேவை',
    MOBILE_VALIDATION_ERROR: 'சரியான 10 இலக்க அலைபேசி எண்ணை உள்ளிடவும்',

    // Help text
    HELP_TEXT:
      'உங்கள் தகவலை விரைவாகவும் எளிதாகவும் அணுக, அலைபேசி எண் மூலம் தேட, மேலே உள்ள உள்ளீட்டுப் பெட்டியைப் பயன்படுத்தவும்.',

    // WhatsApp messages
    WHATSAPP_SHARE_PREFIX: `${PREVIOUS_YEAR} அருள்மிகு மல்லிகார்ஜுன சுவாமி திருக்கோயில், கொண்டறங்கி கீரனூர், சித்திரா பௌர்ணமி பத்திரிகை டவுன்லோட் லிங்க், `,
    WHATSAPP_AGENDA_PREFIX: 'திருவிழா நிகழ்ச்சி நிரல் டவுன்லோட் லிங்க், ',
    CORRECTION_WHATSAPP: 'Correction required for donor id: ',

    // Common
    DASH: '--',
    LOADING_DATA: 'தகவல் எடுக்கப்படுகிறது...',
    SANDHA_RECORDS_COUNT: '{count} சந்தா பதிவுகள் உள்ளன',

    // NotFound
    NOT_FOUND_TITLE: '404 - Page Not Found',
    NOT_FOUND_MESSAGE: 'The page you are looking for does not exist.',

    // Function Completed
    FUNCTION_COMPLETED_TITLE: '🙏 விழா நிறைவடைந்தது',
    FUNCTION_COMPLETED_MESSAGE: `${CURRENT_YEAR + 1} ஆண்டுக்கான புதிய தரவுகள் அடுத்த வருடம் ஜனவரி மாத இறுதியில் வெளியிடப்படும். ${CURRENT_YEAR} ஆண்டு விழாவிற்கு ஒத்துழைப்பு கொடுத்த எல்லா நல்ல உள்ளகளுக்கும் திருப்பணி குழு சார்பாக நன்றி.`,
    FUNCTION_COMPLETED_ARCHIVES_LABEL: 'ஆண்டு வாரியாக தரவுகளைப் பார்க்க',
    FUNCTION_COMPLETED_BUTTON: 'புத்தக விவரங்களைக் காண',

    // Footer
    PREVIOUS_YEAR_LINK: `${PREVIOUS_YEAR} புத்தக விவரங்களைக் காண, இங்கே கிளிக் செய்யவும்.`,

    // Countdown
    LAUNCH_DATE: config.launchDate,
    COUNTDOWN_TITLE: '🚀 விரைவில்',
    COUNTDOWN_SUBTITLE: `ஸ்ரீ கைலாய ஆஸ்ரமத்தின் ${time.festivalCount}ஆம் ஆண்டு விழாவிற்கான, ${CURRENT_YEAR} அழைப்பிதழ் தரவுகளுடன் நமது செயலி மீண்டும் புதுப்பிக்கப்பட்டு வருகிறது.`,
    COUNTDOWN_DAYS: 'Days',
    COUNTDOWN_HOURS: 'Hours',
    COUNTDOWN_MINUTES: 'Minutes',
    COUNTDOWN_SECONDS: 'Seconds',
    COUNTDOWN_PREVIOUS_YEAR_TITLE: 'புத்தகக் தரவு மற்றும் அழைப்பிதழ் பார்க்க',
    COUNTDOWN_CLICK_HERE: 'இங்கே கிளிக் செய்யவும்',
  };
};

// Helper function to replace placeholders in text
export const formatText = (text, replacements = {}) => {
  return Object.keys(replacements).reduce(
    (result, key) => result.replace(`{${key}}`, replacements[key]),
    text
  );
};

export default buildTexts;
